module.exports = __webpack_public_path__ + "statics/img/3.efd1a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/case/3.png
// module id = 7HKB
// module chunks = 1